<mat-form-field appearance="fill">
  @if (label) {
    <mat-label>{{ label }} @if (isRequired) {
      <span>*</span>
    }</mat-label>
  }
  <mat-chip-grid #chipGrid>
    @for (value of values; track value) {
      <mat-chip-row [removable]="true" (removed)="remove(value)">
        {{ value }}
        <button matChipRemove>
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
    }
    <input
      [placeholder]="placeholder"
      [formControl]="inputControl"
      [matChipInputFor]="chipGrid"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="addOnBlur"
      (matChipInputTokenEnd)="add($event)"
      (blur)="onTouched()"
      (keypress)="onKeyPress($event)"
      type="text"
      inputmode="numeric"
      matInput
      />
  </mat-chip-grid>
  @if (ngControl?.control?.hasError('required') && ngControl?.control?.touched) {
    <mat-error>
      This field is required
    </mat-error>
  }
</mat-form-field>
